/* eslint-disable */

import green from '@material-ui/core/colors/green';
import grey from '@material-ui/core/colors/grey';
import orange from '@material-ui/core/colors/orange';
import * as themeConstants from '../../../../Constants/Theme/Theme.constants';

/**
 * Create styles for `<DocketsList />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<DocketsList />` styles
 */
const docketsTableStyles = ({ theme }) => {
  const arrow = {
    fontSize: theme.spacing(1) * 2,
    marginRight: theme.spacing(1),
    position: `relative`,
    top: 3,
    transition: `0.5s all`,
  };
  const bar = {
    '&:hover': {
      opacity: 1,
    },
    backgroundColor: `#fff`,
    boxShadow: `#0000003b 0px 0px ${theme.spacing(1)}px`,
    margin: 0,
    opacity: 0.8,
    padding: `${theme.spacing(1)}px ${theme.spacing(1) * 2}px ${theme.spacing(1)}px ${theme.spacing(1) * 2}px`,
    position: `absolute`,
    top: 0,
    transition: `0.7s all`,
    zIndex: 1,
  };
  const downloadBar = { ...bar, padding: `${theme.spacing(1)}px ${theme.spacing(1) * 2}px ${theme.spacing(1)}px ${theme.spacing(1) * 3}px` };

  return {
    account: {
      marginRight: theme.spacing(1) * 2,
    },
    accountIcon: {
      marginLeft: 0,
    },
    actionsColumn: {
      '&:last-child': {
        padding: `${theme.spacing(1) * 0.8}px`,
        textAlign: `right`,
        width: theme.spacing(1) * 6,
      },
    },
    arrowDown: {
      ...arrow,
      marginLeft: theme.spacing(1),
      transform: `rotateZ(90deg)`,
    },
    arrowUp: {
      ...arrow,
      marginLeft: theme.spacing(1),
      transform: `rotateZ(-90deg)`,
    },
    bar,
    checkboxColumn: {
      width: theme.spacing(1) * 6,
      paddingLeft: theme.spacing(1) * 1.5,
    },
    chip: {
      backgroundColor: grey[100],
    },
    chipFeeIcon: {
      color: orange[400],
    },
    chipNoFeeIcon: {
      color: grey[300],
    },
    chipAcceptedIcon: {
      color: themeConstants.BORAL_GREEN,
      position: `relative`,
      left: 6,
    },
    chipNotAcceptedIcon: {
      color: grey[300],
      position: `relative`,
      left: 6,
    },
    chipNotesAddedIcon: {
      color: themeConstants.BORAL_GREEN,
      position: `relative`,
      left: 6,
      marginRight: theme.spacing(1) / 4,
    },
    chipNoNotesAddedIcon: {
      color: grey[300],
      position: `relative`,
      left: 6,
      marginRight: theme.spacing(1) / 4,
    },
    columnsIcon: {
      left: -theme.spacing(1),
      position: `relative`,
    },
    dateRangePicker: {
      height: 0,
    },
    docketsTableRow: {
      '&:hover': {
        backgroundColor: grey[700],
      },
      backgroundColor: `#fff`,
    },
    downloadBar,
    fieldIcons: {
      minWidth: 40,
    },
    folded: {
      height: 0,
      overflow: `hidden`,
      transition: `all 0.3s`,
    },
    hiddenBar: {
      opacity: 0,
      top: -90,
      transition: `0.7s all`,
    },
    noDockets: {
      height: `80vh`,
    },
    menuHeading: {
      padding: `${theme.spacing(1)}px ${theme.spacing(1)}px ${theme.spacing(1)}px ${theme.spacing(1)}px * 0.5`,
    },
    paperClasses: {
      maxHeight: `30%`,
    },
    columnsSelector: {
      maxHeight: `80%`,
    },
    search: {
      margin: theme.spacing(1) * 0.8,
      marginLeft: theme.spacing(1),
    },
    searchIcon: {
      marginTop: theme.spacing(1) * 0.8,
    },
    searchSpinner: {
      marginRight: 4,
      maxHeight: theme.spacing(1) * 2.5,
      maxWidth: theme.spacing(1) * 2.5,
    },
    searchTextFieldFocused: {
      [theme.breakpoints.down(400)]: {
        backgroundColor: `#fff`,
        width: theme.spacing(1) * 20,
        position: `fixed`,
        zIndex: `99999`,
      },
    },
    searchTextField: {
      '&::-ms-clear': {
        display: `none`,
      },
      maxWidth: theme.spacing(1) * 24,
    },
    spinner: {
      animation: `1s spinnerAnimation`,
      color: theme.palette.grey[500],
      marginTop: -theme.spacing(1) * 11,
    },
    statusCompleted: {
      backgroundColor: green[500],
      color: `#fff`,
    },
    table: {
      marginBottom: theme.spacing(1) * 9,
      marginTop: theme.spacing(1) * 9,
    },
    tableCell: {
      padding: `0 ${theme.spacing(1) * 1.5}px 0  ${theme.spacing(1) * 1.5}px`,
    },
    tableCellContent: {
      maxWidth: 150,
      overflow: `hidden`,
      textOverflow: `ellipsis`,
      whiteSpace: `nowrap`,
    },
    tableHeaderCell: {
      '&:hover': {
        backgroundColor: grey[300],
      },
      padding: `0 ${theme.spacing(1) * 1.5}px 0  ${theme.spacing(1) * 1.5}px`,
    },
    terms: {
      padding: `0px 0px ${theme.spacing(1) * 2}px ${theme.spacing(1)}px`,
    },
    unfolded: {
      height: `3rem`,
      overflow: `hidden`,
      transition: `all 0.3s`,
    },
    warningIcon: {
      marginLeft: -theme.spacing(1) * 0.5,
    },
    zippingSpinner: {
      marginTop: theme.spacing(1) * 2,
      marginBottom: theme.spacing(1) * 2,
    },
    tooltip: {
      left: 0,
      width: 220,
      position: `absolute`,
    },
  };
};

export default docketsTableStyles;
